import { pendingPlan } from '../../premium/billingIntent';
import "./RegisterSuccessModal.css";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { FaArrowRight, FaCheck, FaTimes } from "react-icons/fa";
import { Capacitor } from "@capacitor/core";

export default function RegisterSuccessModal({ onClose }) {
    const navigate = useNavigate();
    const { t } = useTranslation();

    return (
        <div className="modal-overlay reg-success-overlay" role="dialog" aria-modal="true">
            <div className="reg-confirm-modal success">
                {/* <button type="button" className="reg-success-close" onClick={onClose} aria-label="Fermer">
                    <FaTimes />
                </button> */}
                <div className="reg-success-orbit orbit-one" />
                <div className="reg-success-orbit orbit-two" />
                <div className="reg-success-icon"><FaCheck /></div>
                {/* <span className="reg-success-eyebrow">CARRERUP / CONFIRMATION</span> */}
                <h3>{t("registerSuccess.title")}</h3>
                <p>{t("registerSuccess.text")}</p>
                <p className="reg-success-sub">{t("registerSuccess.subtitle")}</p>
                <button
                    className="reg-btn-confirm"
                    onClick={() =>
                        navigate(
                            (Capacitor.isNativePlatform() || pendingPlan())
                                ? "/login"
                                : "/"
                        )
                    }
                >
                    {t("registerSuccess.button")} <FaArrowRight />
                </button>
            </div>
        </div>
    );
}
